import { render, staticRenderFns } from "./FleetNew.vue?vue&type=template&id=2733cc59"
import script from "./FleetNew.vue?vue&type=script&lang=ts"
export * from "./FleetNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports